import Wrapper from "./Wrapper";
import IntroSection from "./IntroSection";
import Frontend from "./frontend";
import Backend from "./backend";
import DevOps from "./DevOps";
const OfferPage = () => {
  return (
    <Wrapper>
      <IntroSection />
      <Frontend />
      <Backend />
      <DevOps />
    </Wrapper>
  );
};
export default OfferPage;
